const GenerateComparisonTable = () => {
  type CheckedItem = {
    id: string;
    pId: string;
    pImg: string;
  };

  const maxChecked = 4;
  const checkedList: CheckedItem[] = [];

  const path = window.location.pathname;
  const input = document.querySelector<HTMLInputElement>('input[name="from"]');
  if (input) input.value = path;

  const checkboxes = document.querySelectorAll<HTMLInputElement>('[name="comparison"]');
  const comparisonSelect = document.querySelector<HTMLElement>('.l-products__comparison-select');


  /* -------------------------------------
      UI 更新
  ------------------------------------- */
  function updateCheckboxDisabledState() {
    const disable = checkedList.length >= maxChecked;
    checkboxes.forEach((checkbox) => {
      if (!checkbox.checked) checkbox.disabled = disable;
    });
  }

  function updateComparisonSelectClass() {
    if (!comparisonSelect) return;

    if (checkedList.length > 0) {
      comparisonSelect.classList.add('on');
    } else {
      comparisonSelect.classList.remove('on');
    }
  }

  function updateComparisonSlotUI() {
    const items = document.querySelectorAll<HTMLElement>(
      '.l-products__comparison-select-list-item'
    );

    // リセット
    items.forEach((item) => {
      item.classList.remove('on');
      item.dataset.id = '';

      const input = item.querySelector<HTMLInputElement>('input');
      if (input) input.value = '';

      const img = item.querySelector<HTMLImageElement>('figure img');
      if (img) img.src = '';

      const nameEl = item.querySelector<HTMLElement>('.name');
      if (nameEl) nameEl.textContent = '';
    });

    checkedList.slice(0, 4).forEach((entry, index) => {
      const item = items[index];
      if (!item) return;

      item.classList.add('on');
      item.dataset.id = entry.id;

      const inputPId = item.querySelector<HTMLInputElement>('input[name^=pId-]');
      if (inputPId) inputPId.value = entry.pId;

      const img = item.querySelector<HTMLImageElement>('figure img');
      if (img) img.src = entry.pImg;

      const nameEl = item.querySelector<HTMLElement>('.name');
      if (nameEl) nameEl.textContent = entry.pId;
    });
  }


  /* -------------------------------------
      クエリパラメータ優先の初期化
  ------------------------------------- */
  function initFromQuery() {
    const urlParams = new URLSearchParams(window.location.search);
    const pIdValues: string[] = [];

    checkedList.length = 0; // reset

    for (let i = 0; i < maxChecked; i++) {
      const key = `pId-${i}`;
      const val = urlParams.get(key);
      if (val && val.trim() !== '') pIdValues.push(val.trim());
    }

    // リセット
    checkboxes.forEach((cb) => {
      cb.checked = false;
      cb.disabled = false;
    });

    if (pIdValues.length === 0) {
      updateCheckboxDisabledState();
      updateComparisonSelectClass();
      updateComparisonSlotUI();
      return;
    }

    // クエリを反映
    pIdValues.forEach((pid) => {
      checkboxes.forEach((cb) => {
        if (cb.value === pid) {
          cb.checked = true;

          const id = cb.id;
          const pImg = cb.dataset.pImg ?? '';

          checkedList.push({ id, pId: pid, pImg });
        }
      });
    });

    updateCheckboxDisabledState();
    updateComparisonSelectClass();
    updateComparisonSlotUI();
  }


  /* -------------------------------------
      ブラウザバック時：checked 状態から復元
  ------------------------------------- */
  function initFromCheckboxState() {
    checkedList.length = 0;

    // disabled が残らないように全解除
    checkboxes.forEach((cb) => (cb.disabled = false));

    checkboxes.forEach((cb) => {
      if (cb.checked) {
        const id = cb.id;
        const pId = cb.value;
        const pImg = cb.dataset.pImg ?? '';
        checkedList.push({ id, pId, pImg });
      }
    });

    updateCheckboxDisabledState();
    updateComparisonSelectClass();
    updateComparisonSlotUI();
  }


  /* -------------------------------------
      初期処理
  ------------------------------------- */

  // 通常ロード時
  window.addEventListener('DOMContentLoaded', () => {
    initFromQuery(); // クエリ優先
  });

  // ブラウザバック（bfcache）
  window.addEventListener('pageshow', (event) => {
    const urlParams = new URLSearchParams(window.location.search);
    const hasQuery = Array.from(urlParams.keys()).some((key) =>
      key.startsWith('pId-')
    );

    if (hasQuery) {
      // ★ クエリ優先
      initFromQuery();
    } else {
      // ★ ブラウザバック時の checkbox 状況を反映
      initFromCheckboxState();
    }
  });


  /* -------------------------------------
      チェックボックスの変更イベント
  ------------------------------------- */
  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', () => {
      const id = checkbox.id;
      const pId = checkbox.value;
      const pImg = checkbox.dataset.pImg ?? '';

      if (checkbox.checked) {
        if (!checkedList.find((item) => item.id === id)) {
          if (checkedList.length >= maxChecked) {
            checkbox.checked = false;
            alert('最大4件まで選択できます');
            return;
          }
          checkedList.push({ id, pId, pImg });
        }
      } else {
        const i = checkedList.findIndex((item) => item.id === id);
        if (i > -1) checkedList.splice(i, 1);
      }

      updateCheckboxDisabledState();
      updateComparisonSelectClass();
      updateComparisonSlotUI();
    });
  });


  /* -------------------------------------
      スロット内 × ボタン
  ------------------------------------- */
  document
    .querySelectorAll<HTMLElement>('.l-products__comparison-select-list-item .close')
    .forEach((closeEl) => {
      closeEl.addEventListener('click', () => {
        const slot = closeEl.closest<HTMLElement>(
          '.l-products__comparison-select-list-item'
        );
        if (!slot) return;

        slot.classList.remove('on');
        const id = slot.dataset.id;
        if (!id) return;

        const checkbox = document.querySelector<HTMLInputElement>(
          `#${id}[name="comparison"]`
        );

        if (checkbox) {
          checkbox.checked = false;
          checkbox.disabled = false;
        }

        const i = checkedList.findIndex((item) => item.id === id);
        if (i > -1) checkedList.splice(i, 1);

        updateCheckboxDisabledState();
        updateComparisonSelectClass();
        updateComparisonSlotUI();
      });
    });
};

export default GenerateComparisonTable;
